export default __webpack_public_path__ + "static/media/alert-close.96841b05.svg";